function NXBagDollar({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      
    >
      <g clipPath="url(#clip0_4287_3031)">
        <path
          d="M7 13.5C10.5 13.5 13 12.2619 13 9.50614C13 6.51075 11.5 4.51382 8.5 3.01613L9.68 1.49846C9.73995 1.39889 9.77246 1.28526 9.77425 1.16909C9.77604 1.05292 9.74704 0.938348 9.69018 0.836979C9.63333 0.73561 9.55065 0.651051 9.45051 0.591872C9.35038 0.532693 9.23636 0.500998 9.12 0.5H4.88C4.76364 0.500998 4.64962 0.532693 4.54949 0.591872C4.44935 0.651051 4.36667 0.73561 4.30982 0.836979C4.25296 0.938348 4.22396 1.05292 4.22575 1.16909C4.22754 1.28526 4.26005 1.39889 4.32 1.49846L5.5 3.02611C2.5 4.53379 1 6.53072 1 9.52611C1 12.2619 3.5 13.5 7 13.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3828 6.80572C8.33524 6.67116 8.26185 6.54881 8.16859 6.44461C7.97023 6.22298 7.68196 6.0835 7.36111 6.0835H6.52257C5.98849 6.0835 5.55554 6.51645 5.55554 7.05052C5.55554 7.50496 5.87197 7.89809 6.31592 7.99521L7.59261 8.27448C8.08996 8.38328 8.44445 8.82401 8.44445 9.33312C8.44445 9.93143 7.95942 10.4169 7.36111 10.4169H6.63888C6.16719 10.4169 5.76591 10.1154 5.61719 9.69463"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 6.08334V5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 11.5001V10.4167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4287_3031">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXBagDollar;
